import { mapGetters, mapMutations } from 'vuex';
import store from './../../store';
import creditNoteReasonService from './../../services/creditNoteReason';
import creditNoteService from './../../services/creditNote';
import Forms from './../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        creditNoteReasonId: {
          value: '',
          type: 'select',
        },
        reasonNote: {
          value: '',
          type: 'div',
        },
        additionalDescription: {
          value: '',
          type: 'textarea',
        },
        // systemAttributes: {
        //   value: '',
        //   type: 'text',
        // },
      }),
      successMessage: '',
      loading: false,
      errors: [],
    };
  },

  computed: {
    ...mapGetters({
      creditNoteReasons: 'allCreditNoteReasons',
      currentCreditNoteReason: 'currentCreditNoteReason',
    }),
  },

  mounted() {
    this.form.hideField('reasonNote');
    this.getResources();
  },

  watch: {
    creditNoteReasons(creditNoteReasons) {
      this.form.setOptions('creditNoteReasonId', creditNoteReasons.map(c => ({ id: c.creditNoteReasonId, name: `${c.creditNoteReasonType}`, description: `${c}` })));
    },

    /**
     * Set system attributes based on the selected option.
     */
    'form.creditNoteReasonId': function () {
      // this.form.systemAttributes = (this.creditNoteReasons[this.form.creditNoteReasonId - 1].creditNoteReasonAttributes != null) ? this.creditNoteReasons[this.form.creditNoteReasonId - 1].creditNoteReasonAttributes.excise_additional_code : '';
      this.form.hideField('reasonNote');
      if (this.creditNoteReasons[this.form.creditNoteReasonId - 1].creditNoteReasonDescription != '') {
        this.form.reasonNote = this.creditNoteReasons[this.form.creditNoteReasonId - 1].creditNoteReasonDescription;
        this.form.showField('reasonNote');
      }
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    getResources() {
      this.loading = true;
      Promise.all([
        creditNoteReasonService.all(),
      ]).then(() => {
        // this.form.disableField('systemAttributes');
        this.loading = false;
      });
    },

    complete() {
      this.form.loading = true;
      const creditNoteReasondata = Object.assign({}, this.form.data(), {
        billStatusId: this.billStatusId,
        orderId: this.orderId,
        date: this.date,
      });

      creditNoteReasonService.update(store.state.route.params.id, creditNoteReasondata)
        .then(() => {
          this.successMessage = this.$t('static.bills.edit.updateSuccess');
          setTimeout(() => {
            this.successMessage = '';
          }, 3000);
          this.loading = false;
          this.form.loading = false;
          this.closeModal();
        }).catch((errors) => {
          this.errors = [errors].filter(item => typeof (item) !== 'undefined');
          this.$message({
            showClose: true,
            message: this.errors,
            type: 'error',
          });
          if (errors.code === 40116) {
            errors = {
              orderId: [this.$t('static.bills.create.orderError')],
            };
          }
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
      this.onClose();
    },
  },

  props: {
    billId: {
      type: Number,
      required: true,
    },

    billStatusId: {
      type: Number,
      required: true,
    },

    orderId: {
      type: Number,
      required: true,
    },

    creditNoteSource: {
      type: Number,
      required: true,
    },

    date: {
      type: String,
      required: true,
    },

    dueDate: {
      type: String,
      required: true,
    },

    onClose: {
      type: Function,
      required: false,
      default: () => {},
    },
  },

  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/creditNoteReason/creditNoteReason.js